import { useEffect, useState } from 'react';
import axios from 'axios';
import { API_CONFIG } from '../config/api';

/**
 * Whether enrollment should use AWS Face Liveness vs legacy photo capture.
 */
export function useBiometricEnrollmentMode(apiBase) {
  const baseUrl = apiBase || API_CONFIG.BASE_URL;
  const [loading, setLoading] = useState(true);
  const [useLiveness, setUseLiveness] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${baseUrl}/biometrics/liveness/config`, { timeout: 15000 })
      .then((res) => {
        if (cancelled) return;
        const { livenessRequired, identityPoolId } = res.data || {};
        setUseLiveness(Boolean(livenessRequired && identityPoolId));
        setLoading(false);
      })
      .catch((err) => {
        if (cancelled) return;
        setError(err.message || 'Could not load biometric settings');
        setUseLiveness(false);
        setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [baseUrl]);

  return { loading, useLiveness, error };
}
